import {Component, ViewChild, OnInit} from '@angular/core';
import { environment } from '../../environments/environment';
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { AuthService } from "../auth.service";
import { SharedModule, NumPipe, UtilsService } from "../shared/shared.module";
import "rxjs/Rx";
import { Subject }    from 'rxjs/Subject';
import { DomSanitizer } from '@angular/platform-browser';
import * as _ from "lodash";
import { saveAs } from 'file-saver/FileSaver';

declare let swal:any;

@Component({
  selector: 'app-detail-bill',
  templateUrl: './detail-bill.component.html',
  styleUrls: ['./detail-bill.component.css']
})
export class DetailBillComponent implements OnInit {

  page: number = 1;
  totalPage: number = 1;
  search: string = "";
  limit: number = 10;
  sortBy: string = 'id';
  revert: boolean = false;
  txtQueryChanged: Subject<string> = new Subject<string>();
  isLoading: boolean = false;

  auth: any;

  billId: number;
  errors = {};
  bills:any = null;

  possibleStatus: any = [
    {value: '', text: 'Toutes les factures'},
    {value: 'TO_SIGN', text: 'Factures à signer'},
    {value: 'SIGNED', text: 'Factures signées'}
  ];

  selectedStatus: string = '';

  constructor(
    private numPipe: NumPipe,
    private authService: AuthService,
    private http: HttpClient,
    private utilsService: UtilsService,
    private router: Router,
    private route: ActivatedRoute,
    public utils: UtilsService,
    public sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.auth = this.authService;
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      else
        this.utilsService.scrollTop();
    });

    this.route.params.subscribe(params => {
      this.billId = params.id;
      if (this.billId) {
        this.authService.getSession();

        this.txtQueryChanged
			  .debounceTime(500) // wait x sec after the last event before emitting last event
			  .distinctUntilChanged() // only emit if value is different from previous value
			  .subscribe(model => {
          this.search = model;
          this.page = 1;
          this.getBills();
        });
        this.getBills();
      }
    });
  }

  goBack() {
    this.router.navigate(['administration', 'factures']);
  }

  getBills(resetPage = false) {
    this.isLoading = true;
    this.errors = {};

    if (resetPage == true)
      this.page = 1;

    var query = "?search=" + this.search + "&limit=" + this.limit + "&page=" + this.page + "&sortBy=" + this.sortBy + "&revert=" + this.revert + '&status=' + this.selectedStatus ;

    this.http.get(environment.API_PATH + '/bill/' + this.billId + '/pharmacy-bills' + query, {withCredentials: true})
	  .subscribe(
      data => {
        this.bills = data['rows'];
        this.totalPage = Math.ceil(data['count'] / this.limit) ;
        this.isLoading = false;
      },
      err => {
        var errors = err.error;
        this.isLoading = false;
        if (errors.error) {
          if (errors.error.status === 401) {

            this.router.navigate(['/connexion']);
          } else if (errors.error.status === 403) {
            if (errors.error.details.redirect)
              this.router.navigate([errors.error.details.redirect]);
            else
              this.router.navigate(['connexion']);
          } else {
            this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
          }
        } else {
          this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
        }
      });
  }

  changePage(num: number, n:number = null): void {
    if (n)
      this.page = this.numPipe.transform(num, n);
    else
      this.page = num;

    this.getBills();
  };

  sortTable(sortBy: string): void {
    if (this.sortBy === sortBy)
      this.revert = !this.revert;
    else
      this.revert = false;
    this.sortBy = sortBy;
    this.getBills();
  }

  onSearchChange(query:string) {
    this.txtQueryChanged.next(query);
  }

  seeBill(bill) {
    this.isLoading = true;
    this.http.get(environment.API_PATH + '/bill/pharmacy_bill_file/' + bill.id, {withCredentials: true})
	  .subscribe(
      data => {
        this.isLoading = false;
        let blob = new Blob([new Uint8Array(data['file'].data)], {type: "application/pdf"});
        let fileUrl = window.URL.createObjectURL(blob) + '#scrollbar=0&amp;view=FitV';
        swal({
          title: 'Attention',
          html: "<object style='width: 60vw;height: 60vh;margin-left: 50px;margin-right: 50px;' data='" + fileUrl + "' type='application/pdf'></object>",
          customClass: 'swal-wide',
          type: 'warning',
          confirmButtonColor: '#49B0D6',
          confirmButtonText: 'Oui'
        }).then(() => {}, () => {});
      },
      err => {
        var errors = err.error;
        this.isLoading = false;
        if (errors.error) {
          if (errors.error.status === 401) {
            this.router.navigate(['/connexion']);
          } else if (errors.error.status === 403) {
            if (errors.error.details.redirect)
              this.router.navigate([errors.error.details.redirect]);
            else
              this.router.navigate(['connexion']);
          } else {
            this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
          }
        } else {
          this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
        }
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/detail-bill/detail-bill.component.ts